import { Directive,HostListener,Input} from '@angular/core';
@Directive({
  selector: '[appOnlycoin]'
})
export class OnlycoinDirective {
  constructor() { }
  @Input('appOnlycoin') date:String;
  @HostListener('keypress', ['$event']) onkeypress(ev) {
    let valid=false;
    if((ev.charCode >= 48 && ev.keyCode <= 57)){
      valid=true;
    }
    if( (ev.charCode == 46 || ev.charCode == 44)){
      valid=true;
    }
    if (!valid){
      ev.preventDefault();
    }
   }
  @HostListener('blur', ['$event']) onblur(event) {
    if(event.target.value!=undefined && event.target.value!=""){
      if(event.target.value.length>1){
        event.target.value=this.formatCurrency(event,"blur");
      }
    }
  }
  @HostListener('keyup', ['$event']) onkeyup(event) {
    if(event.target.value!=undefined && event.target.value!=""){
      if(event.target.value[0]!="$"){
        event.target.value="$"+event.target.value;
      }
      if(event.target.value[1]==0){
       // event.target.value=event.target.value.replace("0","");
      }
      if(event.target.value.length>1){
        event.target.value=this.formatCurrency(event,"keyup");
      }
    }
  }
  formatNumber(n) {
    // format number 1000000 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  formatCurrency(event, blur) {
    let value = (<HTMLInputElement>event.target).value;
    // don't validate empty input
    if (value === "") { return; }
    // original length
    // var original_len = value.length;
    // initial caret position
    // var caret_pos = event.target.selectionStart;
    // check for decimal
    if (value.indexOf(".") >= 0) {
      // get position of first decimal
      // this prevents multiple decimals from
      // being entered
      var decimal_pos = value.indexOf(".");
      // split number by decimal point
      var left_side = value.substring(0, decimal_pos);
      var right_side = value.substring(decimal_pos);
      // add commas to left side of number
      left_side = this.formatNumber(left_side);
      // validate right side
      right_side = this.formatNumber(right_side);
      // On blur make sure 2 numbers after decimal
      if (blur === "blur") {
        right_side += "00";
      }
      // Limit decimal to only 2 digits
      right_side = right_side.substring(0, 2);
      // join number by .
      value = "$" + left_side + "." + right_side;
    }
    else {
      // no decimal entered
      // add commas to number
      // remove all non-digits
      value = this.formatNumber(value);
      value = "$" + value;
      // final formatting
      if (blur === "blur") {
        value += ".00";
      }
    }
    return value;
  }
}
